import { render, staticRenderFns } from "./Packages.vue?vue&type=template&id=4eff9267&scoped=true"
import script from "./Packages.vue?vue&type=script&lang=js"
export * from "./Packages.vue?vue&type=script&lang=js"
import style0 from "./Packages.vue?vue&type=style&index=0&id=4eff9267&prod&lang=scss&scoped=true"
import style1 from "./Packages.vue?vue&type=style&index=1&id=4eff9267&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eff9267",
  null
  
)

export default component.exports